<template>
  <div>
    <nav class="customHeader1">
      <NavDrawer v-model="drawer" />
      <SettingsDrawer v-model="settings" />
      <v-app-bar style="z-index: 8" color="navbar" flat app>
        <v-btn
          v-if="isDashboard && !$vuetify.breakpoint.mobile"
          icon
          color="grey darken-3"
          @click="drawer = !drawer"
        >
          <v-icon>mdi-menu</v-icon>
        </v-btn>
        <v-btn
          v-if="!isDashboard"
          class="removeBtnBackground"
          :ripple="false"
          icon
          color="grey darken-3"
          @click="goBack"
        >
          <v-icon> mdi-arrow-left</v-icon>
        </v-btn>

        <v-toolbar-items v-if="isDashboard">
          <v-btn class="removeBtnBackground" text :ripple="false">
            <img
              class="mr-2"
              width="110"
              src="https://thg.blob.core.windows.net/public-images/bt_logo.svg"
            />
          </v-btn>
        </v-toolbar-items>

        <v-toolbar-title
          v-if="!isDashboard"
          class="text-uppercase pl-0"
          style="width: 185px"
        >
          {{ $route.meta.headerName ? $route.meta.headerName : headerName }}
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-toolbar-items
          v-if="
            !$vuetify.breakpoint.xs &&
            profile &&
            profile.contacts &&
            isTrysilhus === false &&
            profile.contacts.length > 1
          "
          class="ml-2 headline d-none d-md-flex"
        >
          <v-menu :open-on-hover="true" offset-y>
            <template v-slot:activator="{ on }">
              <v-btn text v-on="on">
                <v-icon dark>mdi-chevron-down</v-icon>
                {{ profile.contact.name }}
              </v-btn>
            </template>
            <v-list color="cardSurface">
              <div v-for="(contact, index) in contacts" :key="index" ripple>
                <v-list-item @click="setActiveContact(contact)">
                  {{ contact.contactName }}
                </v-list-item>
              </div>
            </v-list>
          </v-menu>
        </v-toolbar-items>

        <v-btn
          v-if="showTableBtn && $vuetify.breakpoint.mobile"
          icon
          height="44"
          width="44"
          @click="setShowTable(!showTable)"
        >
          <v-icon>{{ showTable ? "mdi-view-grid" : "mdi-view-list" }}</v-icon>
        </v-btn>

        <v-btn
          v-if="isTrysilhus"
          icon
          height="44"
          width="44"
          @click.stop="goToSimployer"
        >
          <v-img
            max-height="24"
            max-width="24"
            src="@/assets/icons/simployer.png"
          ></v-img>
        </v-btn>

        <div v-if="isKiosk">
          <v-btn color="primary" depressed block @click="logout">
            <v-icon left>mdi-logout-variant</v-icon>
            Logg ut
          </v-btn>
        </div>

        <v-btn
          v-if="profile"
          v-haveRoleFilter.onlyKiosk="['PRL']"
          icon
          height="44"
          width="44"
          @click="settings = !settings"
        >
          <v-icon>mdi-cog-outline</v-icon>
        </v-btn>

        <template
          v-slot:extension
          v-if="$vuetify.breakpoint.xs && tabs && tabs.length > 0"
        >
          <v-tabs fixed-tabs background-color="navbar" color="secondaryText">
            <v-tab v-for="(tab, index) in tabs" :key="index">
              {{ tab.name }}
            </v-tab>
          </v-tabs>
        </template>
      </v-app-bar>
    </nav>
    <ConfirmDialog
      v-model="showConfirmSimployer"
      title="Timeregistrering"
      icon="mdi-calendar-clock"
      text="Du blir nå videreført til
    timeregistrering. Her har du <br/>
    <strong class='text-decoration-underline'>10 minutter</strong>, før du blir
    logget ut!"
      btnActionName="Gå til timeregistrering"
      @action="openSimployer"
    />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import api from "@/api/api";
import { mapGetters, mapActions } from "vuex";
import { logout } from "@/helpers/logout";

import NavDrawer from "@/components/shared/navigation/NavDrawer.vue";
import SettingsDrawer from "@/components/shared/navigation/SettingsDrawer.vue";
import ConfirmDialog from "@/components/shared/dialog/ConfirmDialog.vue";

export default Vue.extend({
  name: "Navbar",
  data: () => ({
    drawer: null,
    settings: false,
    showConfirmSimployer: false,
    logout,
  }),
  methods: {
    ...mapActions({
      setShowTable: "tables/setShowTable",
    }),
    changeDarkMode() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    },
    goBack() {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push({ name: "Dashboard" });
    },
    openSimployer() {
      this.showConfirmSimployer = false;
      (window as any).winSimployer = window.open(
        "https://trysilhus.capitech.no/apps/MinCapitech/",
        "_blank"
      );
      if (this.isKiosk) {
        this.$emit("openSimployer");
      }

      // _self
      // window.open("https://portal.simployer.com/logout", "_blank");
    },
    goToSimployer() {
      if (this.isKiosk) {
        this.showConfirmSimployer = true;
      } else {
        this.openSimployer();
      }
    },

    async setActiveContact(contact: any) {
      //Change active contact/company
      await api.setActive(contact).then(() => {
        //Refresh and go to home page
        window.location.href = process.env.VUE_APP_REDIRECTURI || "";
      });
    },
  },
  computed: {
    ...mapGetters({
      profile: "shared/profile",
      isTrysilhus: "shared/isTrysilhus",
      showTable: "tables/showTable",
      headerName: "shared/headerName",
      isKiosk: "shared/isKiosk",
      showConfirmMessage: "shared/showConfirmMessage",
    }),
    isDashboard(): boolean {
      return this.$route.name === "Dashboard";
    },
    tabs(): Array<any> {
      return this.$route.meta?.tabs;
    },
    contacts(): Array<any> {
      return this.profile?.contactPersonRelations.filter(
        (x) => x.contactId !== this.profile.contact.id && x.inActive != true
      );
    },
    showTableBtn(): boolean {
      return this.$route.meta?.tableBtn;
    },
  },
  components: {
    NavDrawer,
    SettingsDrawer,
    ConfirmDialog,
  },
});
</script>

<style lang="scss">
.customHeader1 {
  Header {
    padding-top: calc(0px + env(safe-area-inset-top)) !important;
    height: calc(64px + env(safe-area-inset-top)) !important;
  }

  .v-toolbar__content {
    height: 65px !important;
  }

  header.theme--dark {
    .v-toolbar__title {
      color: var(--v-darkText-base) !important;
    }
    // position: relative;
    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 250px;
      height: 100%;
      background-color: var(--v-primary-base);
      border-bottom-right-radius: 24px;
    }
  }
}
</style>
